import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect } from 'react'
import Pagination from '../../layout/Pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import SearchInput from '../../layout/SearchInput'
import { Table } from 'react-bootstrap'
import { buildPriceListApiUrl } from './helpers/priceListUrlHelpers'

const ClientsPriceListTab = ({ id }) => {
  const [data, setData] = useState([])
  const [isFetching, setIsFetching] = useState(true)
  const [perPage] = useState(25)
  const [totalPages, setTotalPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [query, setQuery] = useState('')

  useEffect(() => {
    fetchClients()
  }, [currentPage, query])

  const fetchClients = () => {
    const params = new URLSearchParams({
      page: currentPage,
      per_page: perPage,
      price_list_context: true
    })
    if (query) params.set('q', query)

    authFetch(`${buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists', id, 'clients')}?${params.toString()}`, {
      method: 'GET',
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setData(data['table'])
        setIsFetching(false)
        setTotalPages(Math.ceil(data['count'] / perPage))
      })
      .catch((e) => console.log(e))
  }

  const handlePaginationClick = (event) => {
    if (event.target.tagName === 'A') handlePagination(event.target)
    else if (event.target.tagName === 'svg') handlePagination(event.target.parentNode)
    else if (event.target.tagName === 'path') handlePagination(event.target.parentNode.parentNode)
  }

  const handlePagination = (target) => {
    if (target.id === 'first-page' && currentPage !== 1) {
      setCurrentPage(1)
    } else if (target.id === 'last-page' && currentPage !== totalPages) {
      setCurrentPage(totalPages)
    } else if (target.id === 'previous-page' && currentPage !== 1) {
      setCurrentPage((prev) => prev - 1)
    } else if (target.id === 'next-page' && currentPage !== totalPages) {
      setCurrentPage((prev) => prev + 1)
    }
  }

  const handleSearch = (text) => {
    // text viene desde SearchInput sólo cuando presionas Enter
    setQuery(text)
    setCurrentPage(1)
  }

  const deleteSearch = () => {
    setQuery('')
    setCurrentPage(1)
  }

  const showModel = (event) => {
    event.preventDefault()
    const id = event.target.id
    window.location = `/clientes/${id}/detalles`
  }

  return (
    <div>
      <div className="title-and-search-containter mt-30">
        <h4 className="">Clientes asignados a esta lista de precio:</h4>

        <div className="search-input-containter mb-20">
          <SearchInput
            query={query}
            onSearch={handleSearch}
            placeholder="Buscar clientes por código o nombre"
          />
        </div>
      </div>

      <div>
        <Table hover responsive>
          <thead className="table-header-gray">
            <tr>
              <th className="vertical-align-middle">
                <span className="th-header-text">CÓDIGO</span>
              </th>
              <th className="table-header-tab">
                <span className="th-header-text">NOMBRE</span>
              </th>
              <th className="table-header-tab">
                <span className="th-header-text">DIRECCIÓN</span>
              </th>
            </tr>
          </thead>

          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="3" className="td-text-limited td-text-limited-space">
                  Obteniendo datos...
                </td>
              </tr>
            )}

            {!isFetching &&
              data?.length > 0 &&
              data.map((model, index) => (
                <tr className="cursor-pointer" key={index}>
                  <td id={model.id} onClick={showModel}>
                    {model.db_ref}
                  </td>
                  <td id={model.id} onClick={showModel}>
                    {model.commercial_name || model.customer_name_db_ref || 'N/A'}
                  </td>
                  <td id={model.id} onClick={showModel}>
                    {model.street || model.location_description || 'N/A'}
                  </td>
                </tr>
              ))}

            {!isFetching && data?.length === 0 && (
              <tr>
                <td colSpan="4" className="td-text-limited td-text-limited-space">
                  No hay resultados
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <nav className="index-table">
            <Pagination
              current_page={currentPage}
              total_pages={totalPages}
              handle_pagination={handlePaginationClick}
            />
          </nav>
        )}
      </div>
    </div>
  )
}

export default ClientsPriceListTab
